<template>
  <div>
    <div class="news-box">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="news-section">
              <div class="news-title">{{ $t("header.cases") }}</div>
              <div class="news-list">
                <div class="company-news">
                  <h5>{{ $t("header.equipment") }}</h5>
                  <a
                    href="javascript:;"
                    v-for="item in titleList"
                    :key="item.id"
                    :class="[item.isActive ? 'active' : '']"
                    @click="handleChange(item.id)"
                    >{{ item.title }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div
              class="news-detail"
              v-for="(item, index) in caseList"
              :key="index"
            >
              <h3>{{ item.title }}</h3>
              <span class="news-time"
                >{{ $t("news.news7") }}：{{ item.time }}</span
              >
              <p v-html="item.text"></p>
              <div class="new-detail-img">
                <div class="img-box">
                  <img :src="item.url_1" class="img-fluid" alt="" />
                </div>
                <div class="img-box">
                  <img :src="item.url_2" class="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      id: "",
      caseList: [],
      titleList: [
        { id: 1, title: this.$t("home.chongqing"), isActive: true },
        { id: 2, title: this.$t("home.sichuan"), isActive: false },
        { id: 3, title: this.$t("home.xinjian"), isActive: false },
        { id: 4, title: this.$t("home.xizang"), isActive: false },
        { id: 5, title: this.$t("home.dunhua"), isActive: false },
        { id: 6, title: this.$t("home.hexin"), isActive: false },
        { id: 7, title: this.$t("home.qiayang"), isActive: false },
        { id: 8, title: this.$t("home.bulage"), isActive: false },
        { id: 9, title: this.$t("home.shimen"), isActive: false },
        { id: 10, title: this.$t("home.lake"), isActive: false },
        { id: 11, title: this.$t("home.jishu"), isActive: false },
        // { id: 12, title: this.$t("home.jishu2"), isActive: false },
        // { id: 13, title: this.$t("home.jishu2"), isActive: false },
        // { id: 14, title: this.$t("home.jishu2"), isActive: false },
        // { id: 15, title: this.$t("home.jishu2"), isActive: false },
        // { id: 16, title: this.$t("home.jishu2"), isActive: false },
        // { id: 17, title: this.$t("home.jishu2"), isActive: false },
        // { id: 18, title: this.$t("home.jishu2"), isActive: false },
        

      ],
      caseList1: [
        {
          title: this.$t("cases.cases_12"),
          time: "2017-11-28",
          text: this.$t("cases.cases_22"),
          url_1: require("@/assets/image/cases-detail-1.png"),
          url_2: require("@/assets/image/cases-detail-2.png"),
        },
      ],
      caseList2: [
        {
          title: this.$t("cases.cases_13"),
          time: "2017-11-28",
          text: this.$t("cases.cases_23"),
          url_1: require("@/assets/image/quxue-1.jpg"),
          url_2: require("@/assets/image/quxue-2.jpg"),
        },
      ],
      caseList3: [
        {
          title: this.$t("cases.cases_14"),
          time: "2017-11-28",
          text: this.$t("cases.cases_24"),
          url_1: require("@/assets/image/suguilong-1.jpg"),
          url_2: require("@/assets/image/suguilong-2.jpg"),
        },
      ],
      caseList4: [
        {
          title: this.$t("cases.cases_15"),
          time: "2017-11-28",
          text: this.$t("cases.cases_25"),
          url_1: require("@/assets/image/kushenta-1.jpg"),
          url_2: require("@/assets/image/kushenta-2.jpg"),
        },
      ],
      caseList5: [
        {
          title: this.$t("cases.cases_16"),
          time: "2017-11-28",
          text: this.$t("cases.cases_26"),
          url_1: require("@/assets/image/dunhua-1.jpg"),
          url_2: require("@/assets/image/dunhua-2.jpg"),
        },
      ],
      caseList6: [
        {
          title: this.$t("cases.cases_17"),
          time: "2017-11-28",
          text: this.$t("cases.cases_27"),
          url_1: require("@/assets/image/hexin-1.jpg"),
          url_2: require("@/assets/image/hexin-2.jpg"),
        },
      ],
      caseList7: [
        {
          title: this.$t("cases.cases_18"),
          time: "2017-11-28",
          text: this.$t("cases.cases_28"),
          url_1: require("@/assets/image/qiayang-1.jpg"),
          url_2: require("@/assets/image/qiayang-2.jpg"),
        },
      ],
      caseList8: [
        {
          title: this.$t("cases.cases_19"),
          time: "2017-11-28",
          text: this.$t("cases.cases_29"),
          url_1: require("@/assets/image/bulage-1.jpg"),
          url_2: require("@/assets/image/bulage-2.jpg"),
        },
      ],
      caseList9: [
        {
          title: this.$t("cases.cases_20"),
          time: "2017-11-28",
          text: this.$t("cases.cases_30"),
          url_1: require("@/assets/image/shimen-1.jpg"),
          url_2: require("@/assets/image/shimen-2.jpg"),
        },
      ],
      caseList10: [
        {
          title: this.$t("cases.cases_21"),
          time: "2017-11-28",
          text: this.$t("cases.cases_31"),
          url_1: require("@/assets/image/zonggelu-1.jpg"),
          url_2: require("@/assets/image/zonggelu-2.jpg"),
        },
      ],
      caseList11: [
        {
          title: this.$t("home.jishu"),
          time: "2017-11-28",
          text: this.$t("cases.cases_32"),
          url_1: require("@/assets/image/jishu-1.jpg"),
          url_2: require("@/assets/image/jishu-2.jpeg"),
        },
      ],
      caseList12: [
        {
          title: this.$t("home.jishu2"),
          time: "2023-9-10",
          text: this.$t("cases.cases_101"),
          url_1: require("@/assets/image/jishu-1.jpg"),
          url_2: require("@/assets/image/jishu-2.jpeg"),
        },
      ],














    };
  },
  watch: {},
  computed: {},
  methods: {
    handleChange(id) {
      switch (id) {
        case 1:
          this.caseList = this.caseList1;
          break;
        case 2:
          this.caseList = this.caseList2;
          break;
        case 3:
          this.caseList = this.caseList3;
          break;
        case 4:
          this.caseList = this.caseList4;
          break;
        case 5:
          this.caseList = this.caseList5;
          break;
        case 6:
          this.caseList = this.caseList6;
          break;
        case 7:
          this.caseList = this.caseList7;
          break;
        case 8:
          this.caseList = this.caseList8;
          break;
        case 9:
          this.caseList = this.caseList9;
          break;
        case 10:
          this.caseList = this.caseList10;
          break;
        case 11:
          this.caseList = this.caseList11;
          break;
          case 12:
          this.caseList = this.caseList12;
          break;




          
      }
      this.titleList.forEach((item) => {
        item.isActive = false;
        if (item.id == id) {
          item.isActive = true;
        }
      });
      console.log(id);
    },
  },
  created() {
    this.id = this.$route.query.id;
    if (this.$route.query.id == 1) {
      this.caseList = this.caseList1;
    } else if (this.$route.query.id == 2) {
      this.caseList = this.caseList2;
    } else if (this.$route.query.id == 2) {
      this.caseList = this.caseList2;
    } else if (this.$route.query.id == 3) {
      this.caseList = this.caseList3;
    } else if (this.$route.query.id == 4) {
      this.caseList = this.caseList4;
    } else if (this.$route.query.id == 5) {
      this.caseList = this.caseList5;
    } else if (this.$route.query.id == 6) {
      this.caseList = this.caseList6;
    } else if (this.$route.query.id == 7) {
      this.caseList = this.caseList7;
    } else if (this.$route.query.id == 8) {
      this.caseList = this.caseList8;
    } else if (this.$route.query.id == 9) {
      this.caseList = this.caseList9;
    } else if (this.$route.query.id == 10) {
      this.caseList = this.caseList10;
    } else {
      this.caseList = this.caseList11;
    }
    this.titleList.forEach((item) => {
      item.isActive = false;
      if (item.id == this.id) {
        item.isActive = true;
      }
    });
    console.log(this.id);
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.news-box {
  padding: 100px 0;
}
.news-section {
  padding: 0 20px;
  margin-bottom: 25px;
  .news-title {
    background: url("../../assets/image/news-1.png") no-repeat;
    background-position: center;
    background-size: cover;
    height: 100px;
    font-size: 26px;
    font-weight: 800;
    color: #fefefe;
    text-align: center;
    line-height: 100px;
  }
  .news-list {
    background-color: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(5, 78, 164, 0.2);
    margin-top: 5px;
    padding: 30px;
    .company-news {
      margin-bottom: 20px;
    }
    h5 {
      font-size: 18px;
      font-weight: 400;
      color: #064ea4;
    }
    a {
      display: block;
      text-indent: 1em;

      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 14px;
      color: #343434;
      line-height: 30px;
      &:nth-child(n):not(:last-child) {
        border-bottom: 1px solid #e3e3e3;
      }
    }
  }
}
.active {
  color: #064ea4 !important;
}
.news-detail {
  h3 {
    font-size: 18px;
    font-weight: bold;
    color: #666666;
    text-align: center;
  }
  span {
    display: block;
    margin: 53px 0 27px 0;
    font-size: 14px;
    color: #666666;
  }
  p {
    font-size: 14px;
    color: #333333;
    text-indent: 2em;
    line-height: 26px;
    span {
      display: block;
      width: 20px;
    }
  }
}
.new-detail-img {
  display: flex;
  justify-content: space-between;
  padding-top: 15px;

  .img-box {
    width: 49%;
  }
}
@media (max-width: 1024px) and (min-width: 768px) {
  .news-section .news-title {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }
  .news-section .news-list {
    padding: 25px 15px;
    h5 {
      font-size: 16px;
    }
  }
  .news-box {
    padding: 50px 0;
  }
}
@media (max-width: 767px) and (min-width: 320px) {
  .news-section .news-title {
    background-size: 100%;
    height: 50px;
    line-height: 50px;
  }
  .news-section {
    padding: 0;
    .news-title {
      font-size: 16px;
    }
    .news-list {
      padding: 15px;
    }
    .company-news {
      h5 {
        font-size: 14px;
      }
      a {
        font-size: 12px;
      }
    }
  }
  .news-box {
    padding: 50px 0;
  }
  .news-detail {
    h3 {
      font-size: 14px;
    }
    .news-time {
      margin: 25px 0 14px 0;
      font-size: 10px;
    }
    p {
      font-size: 12px;
    }
  }
  .new-detail-img {
    flex-wrap: wrap;
    .img-box {
      width: 100%;
      margin-bottom: 9px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
